import { AppRoute } from '@launchpad';
import BaseModule from '@launchpad/logic/module/BaseModule';
import React from 'react';
import AuthorisationImportNavigation from './AuthorisationImportNavigation';

export const NAME = 'authorisation-import';

export default class AuthorisationImportModule extends BaseModule {
  getName() {
    return NAME;
  }

  getPermission() {
    return 'authorisation-import.*';
  }

  getPolicy() {
    return 'Admin:AuthorisationImport:View:*';
  }

  getNavigation() {
    return [
      {
        label: 'Authorisation Import',
        icon: 'download',
        path: '/authorisation-import',
        permission: 'custom.authorisation-import.*',
        policy: 'Admin:AuthorisationImport:View:*',
        children: [],
      },
    ];
  }

  getRoutes(currentUrl = '') {
    return [
      <AppRoute
        permission="custom.authorisation-import.*"
        path="/authorisation-import"
        component={AuthorisationImportNavigation}
      />,
    ];
  }
}
